<template>
  <div class="share-stories-page inner-pages">
    <header>
      <ThePrimaryHeader></ThePrimaryHeader>
    </header>
    <main class="mb-4 profile-page pb-4" v-show="!loading">
      <b-container>
        <div class="row desktop-view">
          <div class="col-lg-3 col-md-12">
            <div class="profile-info shadow-sm">
              <div class="details">
                <div class="profile-img">
                  <img v-if="profileImg" :src="profileImg" :alt="null" width="145" height="145" />
                  <div class="no-img-container" v-if="!profileImg">
                    <img
                      :src="require('@assets/images/new-icons/no_image.svg')"
                      width="44"
                      height="36"
                    />
                    <span>{{ noAvailableImgText }}</span>
                  </div>
                </div>
                <div class="details">
                  <h1>{{ fullName }}</h1>
                  <p class="address">{{ address }}</p>
                  <div class="icon-link-in" v-if="linkedInLink">
                    <b-link
                      :href="linkedInLink"
                      target="_blank"
                      class="linkedin-link"
                    >
                      <img
                        :src="require('@assets/images/linkedin-ic-blue.svg')"
                        class="normal-img"
                        alt="linkedin img"
                        width="25"
                        height="25"
                      />
                      <img
                        :src="require('@assets/images/linkedin-ic.svg')"
                        class="hover-img"
                        alt="linkedin img"
                        width="16"
                        height="16"
                      />
                    </b-link>
                  </div>
                </div>
              </div>
              <div class="about-me" v-if="aboutMeText">
                <div class="inner">
                  <h2>{{ this.getTrans('label.about_me') }}</h2>
                  <p>
                    {{ aboutMeText }}
                  </p>
                </div>
              </div>
              <div class="why-i-colunteer" v-if="whyIvolunteerText">
                <div class="inner">
                  <h2>{{ this.getTrans('label.why_i_volunteer') }}</h2>
                  <p>
                    {{ whyIvolunteerText }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9 col-md-12">
            <AddTabsNavigation
              :tabs="tabs"
              :tabSearch="false"
              :CreateTeam="false"
              @tabIndexChange="changeTabs"
              class="profile-tabs"
            />
            <div class="tab-content shadow-sm">
              <table class="table text-center">
                <thead>
                  <tr>
                    <th
                      v-for="th in headerFilter[tabIndex]"
                      :key="th.id"
                      scope="col"
                      :class="th.text + '-cell'"
                    >
                      <TableHeadFilter
                        :text="th.text"
                        :id="th.id"
                        :selected="headerFilterSelected"
                        :enabled="th.enabled"
                        :count="tabIndex === 1 ? filteredObjectTeams.length : filteredObject.length"
                        @table-head-clicked="handleTableHeadFilter"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in filteredObject" :key="index" v-if="tabIndex === 0">
                    <td>
                      <div class="mission-cell">
                        <div class="image-container">
                          <a :href="value.redirectUrl">
                            <img v-if="value.img" :src="value.img" :alt="null" width="213" height="140" />
                          </a>
                          <div class="no-img-container" v-if="!value.img">
                            <img
                              :src="require('@assets/images/new-icons/no_image.svg')"
                              width="44"
                              height="36"
                            />
                            <span>{{ noAvailableImgText }}</span>
                          </div>
                        </div>
                        <div class="mission-details">
                          <p>
                            <a :href="value.redirectUrl">{{ value.mission_name }}</a>
                          </p>
                          <span class="location-container">
                            <i class="location-icon">
                              <img
                                :src="require('@assets/images/location-black.svg')"
                                :alt="null"
                                width="14"
                                height="18"
                              />
                            </i>
                            {{ value.location }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{ value.organization }}</td>
                    <td>
                      <span v-if="value.duration.hours != 0" class="hours">{{
                        value.duration.hours
                      }}</span
                      ><span v-if="value.duration.hours">h </span>
                      <span
                        v-if="value.duration.minutes != 0"
                        class="minutes"
                        >{{ value.duration.minutes }}</span
                      ><span v-if="value.duration.minutes">m</span>
                    </td>
                  </tr>
                  <tr v-for="(value, index) in filteredObjectTeams" :key="'team-' + index" v-if="tabIndex === 1">
                    <td>
                      <div class="mission-cell">
                        <div class="image-container">
                          <a :href="value.redirectUrl">
                            <img v-if="value.img" :src="value.img" :alt="null" width="213" height="140" />
                          </a>
                          <div class="no-img-container" v-if="!value.img">
                            <img
                              :src="require('@assets/images/new-icons/no_image.svg')"
                              width="44"
                              height="36"
                            />
                            <span>{{ noAvailableImgText }}</span>
                          </div>
                        </div>
                        <div class="mission-details">
                          <p>
                            <a :href="value.redirectUrl">{{ value.team_name }}</a>
                          </p>
                          <span class="location-container">
                            <i class="location-icon">
                              <img
                                :src="require('@assets/images/location-black.svg')"
                                :alt="null"
                                width="14"
                                height="18"
                              />
                            </i>
                            {{ value.location }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{ value.description }}</td>
                    <td>
                      <span v-if="value.duration.hours != 0" class="hours">{{
                          value.duration.hours
                        }}</span
                      ><span v-if="value.duration.hours">h </span>
                      <span
                          v-if="value.duration.minutes != 0"
                          class="minutes"
                      >{{ value.duration.minutes }}</span
                      ><span v-if="value.duration.minutes">m</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="!filteredObject.length > 0 && tabIndex === 0 && dataLoaded"
                class="no-record-found d-flex justify-content-center"
              >
                <div class="no-result-icon-container">
                  <span class="i-text">i</span>
                  <span class="no-record-text">{{
                    this.getTrans("label.no_record_found")
                  }}</span>
                </div>
              </div>
              <div
                  v-if="!filteredObjectTeams.length > 0 && tabIndex === 1 && dataLoadedTeam"
                  class="no-record-found d-flex justify-content-center"
              >
                <div class="no-result-icon-container">
                  <span class="i-text">i</span>
                  <span class="no-record-text">{{
                      this.getTrans("label.no_record_found")
                    }}</span>
                </div>
              </div>

          </div>
          <div
              v-if="tabIndex === 0 && filteredObject.length > 0 && history.pagination.totalPages > 1"
              class="teams-pagination d-md-flex justify-content-end px-3"
          >
            <div class="pagination-wrap">
              <b-pagination
                  :hide-ellipsis=true
                  :total-rows="history.pagination.rows"
                  :per-page="history.pagination.perPage"
                  v-model="history.pagination.currentPage"
              >
              </b-pagination>
            </div>
          </div>
          <div
              v-if="tabIndex === 1 && filteredObjectTeams.length > 0 && history.teamPagination.totalPages > 1"
              class="teams-pagination d-md-flex justify-content-end px-3"
          >
              <div class="pagination-wrap">
                <b-pagination
                    :hide-ellipsis=true
                    :total-rows="history.teamPagination.rows"
                    :per-page="history.teamPagination.perPage"
                    v-model="history.teamPagination.currentPage"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="voluntering-tab">
          <div class="accordion" role="tablist">
            <div no-body class="accordion-head">
              <div header-tag="header" class="p-1" role="tab">
                <div class="profile-dropdown" block v-b-toggle.accordion-1>
                  <span>{{ this.getTrans('label.profile') }}</span>
                  <i>
                    <img
                      :src="require('@assets/images/down-arrow-black.svg')"
                      width="15"
                      height="24"
                    />
                  </i>
                </div>
              </div>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <div class="profile-info profile-mobile shadow-sm">
                  <div class="details">
                    <div class="profile-img">
                      <img v-if="profileImg" :src="profileImg" :alt="null" width="145" height="145" />
                      <div class="no-img-container" v-if="!profileImg">
                        <img
                          :src="require('@assets/images/new-icons/no_image.svg')"
                          width="44"
                          height="36"
                        />
                        <span>{{ noAvailableImgText }}</span>
                      </div>
                    </div>
                    <div class="details">
                      <h1>{{ fullName }}</h1>
                      <p class="address">{{ address }}</p>
                      <div class="icon-link-in">
                        <b-link
                          :href="linkedInLink"
                          target="_blank"
                          class="linkedin-link"
                        >
                          <img
                            :src="
                              require('@assets/images/linkedin-ic-blue.svg')
                            "
                            class="normal-img"
                            alt="linkedin img"
                            width="25"
                            height="25"
                          />
                          <img
                            :src="require('@assets/images/linkedin-ic.svg')"
                            class="hover-img"
                            alt="linkedin img"
                            width="16"
                            height="16"
                          />
                        </b-link>
                      </div>
                    </div>
                  </div>
                  <div class="about-me" v-if="aboutMeText">
                    <div class="inner">
                      <h2>{{ this.getTrans('labe.about_me') }}</h2>
                      <p>
                        {{ aboutMeText }}
                      </p>
                    </div>
                  </div>
                  <div class="why-i-colunteer" v-if="whyIvolunteerText">
                    <div class="inner">
                      <h2>{{ this.getTrans('label.why_i_volunteer') }}</h2>
                      <p>
                        {{ whyIvolunteerText }}
                      </p>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
            <div no-body class="accordion-head">
              <div header-tag="header" class="p-1" role="tab">
                <div class="profile-dropdown" block v-b-toggle.accordion-2>
                  <span>{{ this.getTrans('label.volunteering') }}</span>
                  <i>
                    <img
                      :src="require('@assets/images/down-arrow-black.svg')"
                      width="15"
                      height="24"
                    />
                  </i>
                </div>
              </div>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <ProfileDropdown
                  :options="options[0]"
                  :default="options[0][0].value"
                  @dropdownClicked="handleDropdown('application', $event, $event.isUserInteraction)"
                />
                <VolunteringProfileCardList :List="volunteeringCardList" />
                <div
                  v-if="volunteeringCardList.length > 0 && history.pagination.totalPages > 1"
                  class="teams-pagination d-flex justify-content-center"
                >
                  <div class="pagination-wrap">
                    <b-pagination
                      :hide-ellipsis=true
                      :total-rows="history.pagination.rows"
                      :per-page="history.pagination.perPage"
                      v-model="history.pagination.currentPage"
                      @input="changePage(0, $event)"
                    >
                    </b-pagination>
                  </div>
                </div>
              </b-collapse>
            </div>
            <div no-body class="accordion-head">
              <div header-tag="header" class="p-1" role="tab">
                <div class="profile-dropdown" block v-b-toggle.accordion-3>
                  <span>{{ this.getTrans('label.volunteering_team') }}</span>
                  <i>
                    <img
                      :src="require('@assets/images/down-arrow-black.svg')"
                      width="15"
                      height="24"
                    />
                  </i>
                </div>
              </div>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
                @show="getTeams"
              >
                <ProfileDropdown
                  :options="options[1]"
                  :default="options[1][0].value"
                  @dropdownClicked="handleDropdown('team', $event, $event.isUserInteraction)"
                />
                <VolunteringProfileCardList :List="volunteeringTeamCardList" />
                <div
                  v-if="volunteeringTeamCardList.length > 0 && history.teamPagination.totalPages > 1"
                  class="teams-pagination d-flex justify-content-center"
                >
                  <div class="pagination-wrap">
                    <b-pagination
                      :hide-ellipsis=true
                      :total-rows="history.teamPagination.rows"
                      :per-page="history.teamPagination.perPage"
                      v-model="history.teamPagination.currentPage"
                      @input="changePage(1, $event)"
                    >
                    </b-pagination>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </b-container>
    </main>
    <footer>
      <TheSecondaryFooter></TheSecondaryFooter>
    </footer>
  </div>
</template>

<script>
import ThePrimaryHeader from "@components/Layouts/ThePrimaryHeader";
import TheSecondaryFooter from "@components/Layouts/TheSecondaryFooter";
import AddTabsNavigation from "@components/AddTabsNavigation";
import TableHeadFilter from "@components/TableHeadFilter";
import VolunteringProfileCardList from "@components/VolunteringProfileCardList";
import ProfileDropdown from "@components/ProfileDropdown";
import {
  country,
  getUserDetail,
  skill,
  timezone
} from "@services/service"
import store from "@store";
import {Main as User} from "@services/App/user";
import {mapActions, mapState} from "vuex";
import {
  MODULES,
  APPLICATION_STATUES
} from "@constants";
import constants from "@/constant";

export default {
  name: "UserProfile",

  components: {
    ThePrimaryHeader,
    TheSecondaryFooter,
    AddTabsNavigation,
    TableHeadFilter,
    VolunteringProfileCardList,
    ProfileDropdown,
  },

  data() {
    return {
      dataLoaded: false,
      dataLoadedTeam: false,
      hideEllipsis: true,
      noAvailableImgText: this.getTrans('label.no_image_available'),
      profileImg: '',
      fullName: '',
      address: '',
      linkedInLink: '',
      aboutMeText: '',
      whyIvolunteerText: '',
      tabs: [
        {
          id: 0,
          title: this.getTrans('label.volunteering')
        },
        {
          id: 1,
          title: this.getTrans('label.volunteering_team')
        },
      ],
      tabIndex: 0,
      selectedValue: null,
      options: [
        [
          {
            value: 'mission_a_z',
            text: 'Mission (A to Z)',
            orderBy: 'mission_title',
            orderDir: 'asc'
          },
          {
            value: 'mission_z_a',
            text: 'Mission (Z to A)',
            orderBy: 'mission_title',
            orderDir: 'desc'
          },
          {
            value: 'organization_a_z',
            text: 'Organization (A to Z)',
            orderBy: 'organization_name',
            orderDir: 'asc'
          },
          {
            value: 'organization_z_a',
            text: 'Organization (Z to A)',
            orderBy: 'organization_name',
            orderDir: 'desc'
          },
          {
            value: 'hours_ascending',
            text: 'Hours (Ascending)',
            orderBy: 'timesheet_time',
            orderDir: 'asc'
          },
          {
            value: 'hours_descending',
            text: 'Hours (Descending)',
            orderBy: 'timesheet_time',
            orderDir: 'desc'
          },
        ],
        [
          {
            value: 'team_a_z',
            text: 'Team (A to Z)',
            orderBy: 'name',
            orderDir: 'asc'
          },
          {
            value: 'team_z_a',
            text: 'Team (Z to A)',
            orderBy: 'name',
            orderDir: 'desc'
          },
        ]
      ],
      headerFilter: [
        [
          {
            id: 1,
            text: this.getTrans('label.mission'),
            key: 'mission_title',
            enabled: true
          },
          {
            id: 2,
            text: this.getTrans('label.organisation'),
            key: 'organization_name',
            enabled: true
          },
          {
            id: 3,
            text: this.getTrans('label.hours'),
            key: 'timesheet_time',
            enabled: true
          }
        ],
        [
          {
            id: 1,
            text: this.getTrans('label.team'),
            key: 'name',
            enabled: true
          },
          {
            id: 2,
            text: this.getTrans('label.description'),
            key: 'extracted_team_description',
            enabled: false
          },
          {
            id: 3,
            text: this.getTrans('label.hours'),
            key: 'total_team_hours',
            enabled: false
          }
        ]
      ],
      headerFilterSelected: 1,
      headerFilterValue: 'asc',
      filteredObject: [],
      filteredObjectTeams: [],
      volunteeringCardList: [],
      volunteeringTeamCardList: [],
      history: {
        sorting: {
          sortBy: '',
          sortDesc: true,
          sortDir: 'asc'
        },
        filters: {
          date: null,
          status: null
        },
        pagination: {
          currentPage: 1,
          rows: 1,
          perPage: 10,
          totalPages: 0
        },
        teamPagination: {
          currentPage: 1,
          rows: 1,
          perPage: 10,
          totalPages: 0
        }
      },
      data: [],
      loading: true
    };
  },

  methods: {
    ...mapActions(MODULES.TEAMVOLUNTEERING, [
      'listTeams',
    ]),

    resetTableHeadFilter() {
      this.headerFilterSelected = null;
      this.headerFilterValue = null;
    },

    getHeader(id) {
      const headers = this.headerFilter[this.tabIndex];
      return headers.find(header => header.id === id);
    },

    changePage(tabIndex, page) {
      this.tabIndex = tabIndex;

      if (this.tabIndex === 0) {
        this.history.pagination.currentPage = page;
        this.getApplications(this.history.pagination.currentPage, this.history.sorting.sortBy, this.history.sorting.sortDir);
      } else if (this.tabIndex === 1) {
        this.history.teamPagination.currentPage = page;
        this.getTeams( this.history.teamPagination.currentPage, 'name', this.history.sorting.sortDir);
      }
    },

    changeTabs(tabIndex) {
      this.eventType = tabIndex !== 0;
      this.tabIndex = tabIndex;
      this.history.sorting.sortBy = this.tabIndex === 0 ? 'mission_title' : 'name';

      this.resetTableHeadFilter();

      if (this.tabIndex === 1) {
        this.dataLoadedTeam = false;
        this.filteredObjectTeams = this.getTeams();
      } else {
        this.dataLoaded = false;
        this.filteredObject = this.getApplications();
      }
    },

    handleTableHeadFilter: function(id, filter, event) {
      let page = 1
      this.filter = filter;
      this.headerFilterSelected = id;
      this.headerFilterValue = filter;
      this.history.sorting.sortBy = this.getHeader(id).key;
      this.history.sorting.sortDir = filter;

      if (this.tabIndex === 0) {
        this.getApplications(page, this.history.sorting.sortBy, this.history.sorting.sortDir);
      } else if (this.tabIndex === 1) {
        this.getTeams(page, this.history.sorting.sortBy, this.history.sorting.sortDir);
      }
    },

    handleDropdown(type, selected, isUserInteraction = true) {
      let page = 1;
      const options = this.options[0].concat(this.options[1]);
      const filter = options.find(option => option.value === selected);
      this.history.sorting.sortBy = filter.orderBy;
      this.history.sorting.sortDir = filter.orderDir;

      if (isUserInteraction) {
        if (type === 'application') {
          this.getApplications(page, filter.orderBy, filter.orderDir);
        } else if (type === 'team') {
          this.getTeams(page, filter.orderBy, filter.orderDir);
        }
      }
    },

    async getUserProfileDetail() {
      try {
        this.loadingState(true);
        this.loading = true;
        const response = await getUserDetail({
          user_id: this.$route.params.userID
        });

        // if there are no user data, status is inactive or 0 and user is pseudonymized then redirect to 404
        if (
            !response.data
            || response.data.status === 0
            || (
                response.data.pseudonymize_at !== null
                && response.data.pseudonymize_at !== '0000-00-00 00:00:00'
            )
        ) {
          return this.$router.push('/404');
        }

        let data = response.data;
        this.profileImg = data.avatar;
        this.fullName = data.first_name + ' ' + data.last_name;
        this.aboutMeText = data.profile_text;
        this.whyIvolunteerText = data.why_i_volunteer;
        this.linkedInLink = data.linked_in_url;

        const responseData = await country();
        const userCity = data['city_list'][data.city_id];
        const userCountry = responseData.data.find(item => item[0] === data.country_id);

        if (userCity && userCountry) {
          this.address = userCity + ', ' + userCountry[1];
        } else if (userCountry) {
          this.address = userCountry[1];
        } else {
          this.address = '';
        }

        this.loading = false;
        this.loadingState(false);
        // on first load get the applications and teams and add them on the list
        await this.getApplications();
      } catch (error) {
        return this.$router.push('/404');
      }
    },

    async getTeams(page = 1, orderBy = 'name', orderDir = 'asc') {
      const params = {
        order: {
          by: orderBy,
          direction: orderDir
        },
        page: page,
        perPage: this.history.teamPagination.perPage,
        is_member: 1,
        user_id: this.$route.params.userID
      };

      const { data, pagination } = await this.listTeams(params);
      let dataArray = [];
      data.forEach(team => {
        const teamDescription = team.description.find((data) => {
          return data.language === store.state.defaultLanguage;
        });
        const location = team.country
          ? team.country.languages.find((country) => {
            return parseInt(this.defaultLanguageId) === parseInt(country.language_id);
          }) !== undefined
            ? team.country.languages.find((country) => {
                return parseInt(this.defaultLanguageId) === parseInt(country.language_id);
              }).name
            : team.country.languages[0].name
          : null;
        let time = this.getDurationHoursMins(team.statistics.total_team_hours);

        dataArray.push({
          type: 'team',
          img: team.image,
          team_name: team.name,
          location: location,
          description: teamDescription
            ? teamDescription.content
            : team.description[0].content,
          duration: {
            hours: time.hours,
            minutes: time.minutes
          },
          redirectUrl: '/teams/' + team.id
        });
      });

      this.history.teamPagination.rows = pagination.total;
      this.history.teamPagination.currentPage = pagination.current_page;
      this.history.teamPagination.totalPages = pagination.total_pages;
      this.history.teamPagination.perPage = pagination.per_page;
      this.filteredObjectTeams = dataArray;
      this.volunteeringTeamCardList = dataArray;
      this.dataLoadedTeam = true;

      return this.filteredObjectTeams;
    },

    getDurationHoursMins(time) {
      let hours = 0;
      let minutes = 0;

      if (time === 0 || time === null) {
        hours = 0;
        minutes = 0;
      } else {
        let timeArr = time.split(':');
        hours = parseInt(timeArr[0]);
        minutes = parseInt(timeArr[1]);
      }

      return {
        hours: hours,
        minutes: minutes
      };
    },

    async getApplications(page = 1, orderBy = 'mission_title', orderDir = 'asc') {
      try {
        const params = {
          order_by: orderBy,
          order_dir: orderDir,
          page: page,
          perPage: this.history.pagination.perPage,
          team_only: 0,
          user_id: this.$route.params.userID,
          unique_missions: 1,
          approval_status: [
            APPLICATION_STATUES.COMPLETED,
            APPLICATION_STATUES.ONGOING,
            APPLICATION_STATUES.AUTOMATICALLY_APPROVED
          ]
        };

        const {
          data,
          pagination
        } = await User.getApplications(params);

        let dataArray = [];

        data.forEach(obj => {
          const lang = obj.mission.translations.lengh > 0
            ? obj.mission.translations[0].language_id
            : null;

          const countryLanguage = obj.mission.country.find(
              (obj) => obj.language_id === lang
          );

          let location = countryLanguage
            ? countryLanguage.name
            : obj.mission.country[0].name;

          let time = this.getDurationHoursMins(obj.timesheet.time);

          dataArray.push({
            type: 'application',
            img: obj.mission.image,
            mission_name: obj.mission.title || obj.mission.translations[0].title,
            location: location,
            organization: obj.organization.name,
            duration: {
              hours: time.hours,
              minutes: time.minutes,
            },
            redirectUrl: '/mission-detail/' + obj.mission.id
          });
        });

        this.history.pagination.rows = pagination.total;
        this.history.pagination.currentPage = pagination.current_page;
        this.history.pagination.totalPages = pagination.total_pages;
        this.history.pagination.perPage = pagination.per_page;
        this.filteredObject = dataArray;
        this.volunteeringCardList = dataArray;
        this.dataLoaded = true;

        return this.filteredObject;
      } catch (error) {
        console.log(error);

        this.history.pagination.rows = 0;
        this.history.pagination.currentPage = 1;

        return [];
      }
    },
  },

  filters: {
    formatDuration(value) {
      const number = value.match(/\d+/)[0]; // extract the number from the string
      const letters = value.replace(/\d+/, ""); // extract the letters from the string

      return (
        `<span style="font-size: 24px">${number}</span>` + // make the number larger
        `<span style="font-size: 12px">${letters}</span>`
      ); // make the letters smaller
    },
  },

  created() {
    if (
        (!this.settingEnabled(constants.PREVIEW_PROFILE) && (this.userId === this.$route.params.userID))
        || (!this.settingEnabled(constants.VIEW_OTHER_USER_PROFILE) && (this.userId !== this.$route.params.userID))
    ) {
      this.$router.push('/404');
    }
    else {
      this.getUserProfileDetail();
    }
  },

  computed: {
    ...mapState([
      'defaultLanguageId',
      'userId',
    ]),
  }
};
</script>

<style lang="scss" scoped>
.profile-page {
  margin-top: 125px;
  @media (max-width: 700px) {
    margin-top: 20px;
  }

  .profile-info {
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    margin-bottom: 30px;
    margin-right: 8px;
    padding-bottom: 0px;

    .details {
      background: #f9f9f9;
      position: relative;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;

      .profile-img {
        position: absolute;
        top: -77px;
        left: 50%;
        transform: translate(-50%);
        z-index: 1;
        width: 145px;
        height: 145px;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
        .no-img-container {
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          height: 100%;
          background: #eeeeee;
          img {
            width: 44px;
            height: 36px;
            margin: 0 auto;
            position: relative;
            border-radius: 0;
          }
          span {
            display: block;
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
          }
        }
      }

      h1 {
        margin: 0;
        padding: 0;
        font-size: 23px;
        font-weight: 400;
        line-height: 26px;
      }
    }

    .about-me,
    .why-i-colunteer {
      padding: 20px 30px 0px 30px;

      h2 {
        font-size: 20px;
      }
    }

    .about-me {
      .inner {
        border-bottom: 1px solid #e8e8e8;

        p {
          padding-bottom: 10px;
        }
      }
    }
  }
}

.profile-tabs {
  /deep/.tabs-container .nav-link {
    width: fit-content;
    color: #767676;
  }
  /deep/.tabs-container .active-tab-nav {
    border-bottom: 2px solid #333 !important;
    background: #ffffff !important;
    font-weight: 500;
    color: #333 !important;
  }
}

.tab-content {
  overflow: hidden;
  border-radius: 10px;
  table {
    margin-bottom: 0;
    overflow: auto;
    width: 100%;
    table-layout: fixed;
    th,
    td {
      border: none;
      padding: 0;
    }

    thead {
      th {
        background: #eeeeee;
        font-size: 15px;
        font-weight: 500;
        padding: 30px 20px;

        &:not(:first-child) {
          text-align: left;
        }
        &:nth-child(1) {
          width: 50%;
          border-radius: 10px 0px 0px 0px;
        }
        &:nth-last-child(1) {
          border-radius: 0px 10px 0px 0px;
          width: 25%;
        }
      }
    }

    tbody {
      tr {
        border: solid 1px #e2e2e2;

        td {
          color: rgb(65, 65, 65);

          &:not(:first-child) {
            text-align: left;
            padding: 15px 20px;
          }
        }
      }
      .mission-cell {
        text-align: left;
        display: flex;

        .image-container {
          width: 380px;
          min-height: 140px;
          max-height: 100%;
          position: relative;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .no-img-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
            background: #eeeeee;
            img {
              width: 44px;
              height: 36px;
              margin: 0 auto;
              position: relative;
            }
            span {
              display: block;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              text-align: center;
            }
          }
        }
        .mission-details {
          position: relative;
          padding: 15px 20px;
          width: 100%;

          p {
            font-size: 16px;
            line-height: 22px;
            padding-bottom: 30px;
          }

          .location-container {
            position: absolute;
            bottom: 20px;
            left: 20px;
            font-size: 12px;
            font-weight: 300;

            .location-icon {
              img {
                width: 14px;
                height: 18px;
                margin-top: -4px;
              }
            }
          }
        }
      }
    }
  }
}

.desktop-view {
  display: none;
  @media (min-width: 701px) {
    display: flex;
  }
}

.voluntering-tab {
  display: none;
  @media (max-width: 700px) {
    display: block;
  }

  .accordion {
    .accordion-head:not(:last-child) {
      border-bottom: solid 1px #e2e2e2;
    }
    .accordion-head:last-child:has(.collapsed) {
      border-bottom: solid 1px #e2e2e2;
    }
  }

  .accordion-head {
    padding: 15px 0;
  }
  .not-collapsed {
    i img {
      transition: transform 0.3s ease-out;
      transform: rotate(180deg);
    }
  }
  .profile-dropdown {
    display: flex;
    justify-content: space-between;

    span {
      font-size: 1.5rem;
    }

    i img {
      width: 15px;
      transition: transform 0.3s ease-out;
    }
  }
}
.hours,
.minutes {
  font-size: 23px;
}
.profile-mobile {
  margin-top: 100px;
}
.linkedin-link {
  display: block;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  border: 1px solid #007bb6;
  border-radius: 50%;

  &:hover {
    .normal-img {
      display: none;
    }
    .hover-img {
      display: block;
    }
    background: #007bb6;
  }

  img {
    width: 25px;
    &.hover-img {
      display: none;
    }
  }
}

.teams-pagination {
  padding: 30px 0;
  border: solid 1px #e2e2e2;
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;

  @media (max-width: 701px) {
    border: none !important;
  }

  .active .page-link {
    background: linear-gradient(
      94.97deg,
      rgba(50, 160, 240, 0.1) 5.43%,
      rgba(63, 117, 229, 0.1) 97.43%
    ) !important;
    border: 1px solid #e2e2e2 !important;
    color: #1b86d5 !important;
    font-weight: 700;
    font-size: 16px;
  }
  .page-link {
    font-size: 16px;
    color: #1b86d5;
  }
  .pageInfo {
    display: none;
  }

  @media only screen and (max-width: 770px) {
    .pagination-wrap {
      display: flex;
      justify-content: flex-end;
      padding-right: 1em;
      padding-left: 5px;
      .b-pagination {
        .page-item {
          display: none;
          &:first-child,
          &:last-child {
            display: block;
          }
        }
      }
      .pageInfo {
        display: inline-block;
        font-weight: 400;
        font-size: 14px;
        margin-top: 10px;
        margin-right: 10px;
      }
    }
  }
}
.no-result-icon-container {
  margin-top: 40px;
  height: 400px;

  text-align: center;

  .no-record-text {
    color: #757575;
    font-weight: 400;
    font-size: 16px;
  }

  .i-text {
    margin: 0 auto;
    border-radius: 40px;
    width: 61px;
    height: 61px;
    text-align: center;
    background: linear-gradient(
      94.97deg,
      rgba(172, 219, 74, 0.1) 4.99%,
      rgba(155, 204, 54, 0.1) 96.99%
    );
    display: flex;
    justify-content: center;
    align-items: center;

    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    color: #9bcc36;
    margin-bottom: 12px;
  }
}
.no-result-icon-container {
  margin-top: 120px !important;
  text-align: center;
}
</style>
